


const CHECKOUT_COLORS = [
  { name: 'primary', color: '#BFD4FF' },
  { name: 'secondary', color: '#E1D95A' },
];


const loadTebex = () => import('@tebexio/tebex.js').then((module) => module.default);


export async function launchTebexCheckout({ resolveIdent, onComplete, onError, onClose }) {
  const Tebex = await loadTebex();

  Tebex.checkout.init({
    theme: 'dark',
    colors: CHECKOUT_COLORS,
    closeOnPaymentComplete: false,
    closeOnClickOutside: false,
    closeOnEsc: true,
  });


  const unsubscribers = [];
  const stopListening = () => {
    while (unsubscribers.length) unsubscribers.pop()();
  };

  unsubscribers.push(
    Tebex.checkout.on('payment:complete', () => onComplete?.()),
    Tebex.checkout.on('payment:error', (event) => onError?.(event)),
    Tebex.checkout.on('close', () => {
      stopListening();
      onClose?.();
    }),
  );

  try {
    await Tebex.checkout.launch(resolveIdent);
  } catch (error) {

    stopListening();
    throw error;
  }
}

export async function closeTebexCheckout() {
  const Tebex = await loadTebex();

  return Tebex.checkout.close();
}
